import { render, staticRenderFns } from "./Previred.vue?vue&type=template&id=46ee4d32&"
import script from "./Previred.vue?vue&type=script&lang=ts&"
export * from "./Previred.vue?vue&type=script&lang=ts&"
import style0 from "./Previred.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports